// 生徒情報のエンティティ
export class Student {
  // ユーザーID DB型(*id)
  public user_id?: string;
  // 氏名 DB型(*varchar256)
  public full_name?: string;
  // 氏名カナ DB型(*varchar256)
  public full_name_kana?: string;
  // ニックネーム DB型(*varchar256)
  public nickname?: string;
  // 性別 DB型(*varchar20)
  public gender?: string;
  // 生年月日 DB型(DATE)
  public birth_day?: Date;
  // 受給者証番号 DB型(*varchar64)
  public jyukyusyasyo_bango?: string;
  // 身体障碍者手帳等級 DB型(*varchar20)
  public shintai_shougaisya_grade?: string;
  // その他手帳について DB型(*varchar1024)
  public other_techo_comment?: string;
  // 通所給付決定保護者名 DB型(*varchar256)
  public decision_parent?: string;
  // 裸耳聴力 DB型(*varchar20)
  public naked_ear?: string;
  // 補聴器等について DB型(*varchar256)
  public hearing_aid_about?: string;
  // 補聴聴力について DB型(*varchar64)
  public hearing_aid?: string;
  // 裸耳聴力左 DB型(*varchar20)
  public naked_ear_left?: string;
  // 裸耳聴力右 DB型(*varchar20)
  public naked_ear_right?: string;
  // 補聴聴力左 DB型(*varchar20)
  public hearing_aid_left?: string;
  // 補聴聴力右 DB型(*varchar20)
  public hearing_aid_right?: string;
  // 補聴器等について左 DB型(*varchar256)
  public hearing_aid_about_left?: string;
  // 補聴器等について右 DB型(*varchar256)
  public hearing_aid_about_right?: string;
  // 療育手帳級数 DB型(*varchar20)
  public ryouiku_techo_grade?: string;
  // 保護者フルネーム DB型(*varchar256)
  public parent_full_name?: string;
  // 保護者フルネームカナ DB型(*varchar256)
  public parent_full_name_kana?: string;
  // 郵便番号 DB型(varchar(50))
  public zip_code?: string;
  // 都道府県 DB型(varchar(50))
  public prefecture?: string;
  // 市区町村名 DB型(varchar(256))
  public city_name?: string;
  // 以降の住所 DB型(varchar(256))
  public address_line1?: string;
  // マンション名 DB型(varchar(256))
  public address_line2?: string;
  // 連絡の取れるメールアドレス DB型(varchar(256))
  public email?: string;
  // 保護者の聴覚障害 DB型(varchar(10))
  public hearing?: string;
  // 保護者との連絡手段 DB型(VARCHAR(32))
  public parent_contact_method?: string;
  // 学年 DB型(*varchar64)
  public school_year?: string;
  // 学校名 DB型(*varchar64)
  public school_name?: string;
  // 学校種別 DB型(*varchar64)
  public school_type?: string;
  // 家族の聴覚障害 DB型(*varchar256)
  public family_state?: string;
  // 家族全員で話すときの状況 DB型(*varchar256)
  public talking_with_family?: string;
  // ご希望のコースを教えてください DB型(*varchar20)
  public hope_course?: string;
  // 学校の教科で取り組みたい科目を教えてください DB型(*varchar64)
  public subject_point?: string;
  // どこで知りましたか DB型(*varchar256)
  public where_know?: string;
  // どこで知りましたか（その他） DB型(*varchar256)
  public where_know_other?: string;
  // なぜ申込をしようとしましたか DB型(*varchar256)
  public why_application?: string;
  // 申込理由 DB型(*varchar1024)
  public reason_application?: string;
  // お子様の行動の課題について DB型(*varchar1024)
  public issues?: string;
  // 教育方針 DB型(*varchar1024)
  public education_plan?: string;
  // 「手話」を身につけて欲しいと思いますか？ DB型(*varchar20)
  public needto_sign_language?: string;
  // 「発音」を身につけて欲しいと思いますか？ DB型(*varchar20)
  public needto_pronunciation?: string;
  // 「聴覚活用（音声による教育）」は大切と思いますか？ DB型(*varchar20)
  public needto_hearing?: string;
  // 学校の教科で取り組みたい科目 DB型(*varchar1024)
  public school_subject_needs?: string;
  // 学校以外の教科 DB型(*varchar1024)
  public other_needs?: string;
  // 挿入日時 DB型(@DATETIME)
  public insert_dt?: Date;
  // 難聴学級の有無 DB型(*varchar20)
  public has_deafness_class?: string;
  // 顔写真載せていいか DB型(*flg)
  public can_up_photo?: boolean;
  // 療育手帳 DB型(*varchar512)
  public has_ryouiku_techo?: string;
  // ゆうちょ利用者 DB型(*flg)
  public is_yuucho?: boolean;
  // 会費ペイID DB型(*autokeyFk)
  public kp_id?: number;
  // 会費ペイCSVダウンロード済み DB型(*flg)
  public kp_downloaded?: boolean;
  static fromDB(record: { [column: string]: any; [column: number]: any }): Student {
    const entity = new Student();
    entity.user_id = record['user_id'];
    entity.full_name = record['full_name'];
    entity.full_name_kana = record['full_name_kana'];
    entity.nickname = record['nickname'];
    entity.gender = record['gender'];
    entity.birth_day = record['birth_day'];
    entity.jyukyusyasyo_bango = record['jyukyusyasyo_bango'];
    entity.shintai_shougaisya_grade = record['shintai_shougaisya_grade'];
    entity.other_techo_comment = record['other_techo_comment'];
    entity.decision_parent = record['decision_parent'];
    entity.naked_ear = record['naked_ear'];
    entity.hearing_aid_about = record['hearing_aid_about'];
    entity.hearing_aid = record['hearing_aid'];
    entity.naked_ear_left = record['naked_ear_left'];
    entity.naked_ear_right = record['naked_ear_right'];
    entity.hearing_aid_left = record['hearing_aid_left'];
    entity.hearing_aid_right = record['hearing_aid_right'];
    entity.hearing_aid_about_left = record['hearing_aid_about_left'];
    entity.hearing_aid_about_right = record['hearing_aid_about_right'];
    entity.ryouiku_techo_grade = record['ryouiku_techo_grade'];
    entity.parent_full_name = record['parent_full_name'];
    entity.parent_full_name_kana = record['parent_full_name_kana'];
    entity.zip_code = record['zip_code'];
    entity.prefecture = record['prefecture'];
    entity.city_name = record['city_name'];
    entity.address_line1 = record['address_line1'];
    entity.address_line2 = record['address_line2'];
    entity.email = record['email'];
    entity.hearing = record['hearing'];
    entity.parent_contact_method = record['parent_contact_method'];
    entity.school_year = record['school_year'];
    entity.school_name = record['school_name'];
    entity.school_type = record['school_type'];
    entity.family_state = record['family_state'];
    entity.talking_with_family = record['talking_with_family'];
    entity.hope_course = record['hope_course'];
    entity.subject_point = record['subject_point'];
    entity.where_know = record['where_know'];
    entity.where_know_other = record['where_know_other'];
    entity.why_application = record['why_application'];
    entity.reason_application = record['reason_application'];
    entity.issues = record['issues'];
    entity.education_plan = record['education_plan'];
    entity.needto_sign_language = record['needto_sign_language'];
    entity.needto_pronunciation = record['needto_pronunciation'];
    entity.needto_hearing = record['needto_hearing'];
    entity.school_subject_needs = record['school_subject_needs'];
    entity.other_needs = record['other_needs'];
    entity.insert_dt = record['insert_dt'];
    entity.has_deafness_class = record['has_deafness_class'];
    entity.can_up_photo = record['can_up_photo'];
    entity.has_ryouiku_techo = record['has_ryouiku_techo'];
    entity.is_yuucho = record['is_yuucho'];
    entity.kp_id = record['kp_id'];
    entity.kp_downloaded = record['kp_downloaded'];
    return entity;
  }
  static getTypeFitEntity(value: any): Student {
    const entity = new Student();
    entity.user_id = value.user_id;
    entity.full_name = value.full_name;
    entity.full_name_kana = value.full_name_kana;
    entity.nickname = value.nickname;
    entity.gender = value.gender;
    entity.birth_day = value.birth_day;
    entity.jyukyusyasyo_bango = value.jyukyusyasyo_bango;
    entity.shintai_shougaisya_grade = value.shintai_shougaisya_grade;
    entity.other_techo_comment = value.other_techo_comment;
    entity.decision_parent = value.decision_parent;
    entity.naked_ear = value.naked_ear;
    entity.hearing_aid_about = value.hearing_aid_about;
    entity.hearing_aid = value.hearing_aid;
    entity.naked_ear_left = value.naked_ear_left;
    entity.naked_ear_right = value.naked_ear_right;
    entity.hearing_aid_left = value.hearing_aid_left;
    entity.hearing_aid_right = value.hearing_aid_right;
    entity.hearing_aid_about_left = value.hearing_aid_about_left;
    entity.hearing_aid_about_right = value.hearing_aid_about_right;
    entity.ryouiku_techo_grade = value.ryouiku_techo_grade;
    entity.parent_full_name = value.parent_full_name;
    entity.parent_full_name_kana = value.parent_full_name_kana;
    entity.zip_code = value.zip_code;
    entity.prefecture = value.prefecture;
    entity.city_name = value.city_name;
    entity.address_line1 = value.address_line1;
    entity.address_line2 = value.address_line2;
    entity.email = value.email;
    entity.hearing = value.hearing;
    entity.parent_contact_method = value.parent_contact_method;
    entity.school_year = value.school_year;
    entity.school_name = value.school_name;
    entity.school_type = value.school_type;
    entity.family_state = value.family_state;
    entity.talking_with_family = value.talking_with_family;
    entity.hope_course = value.hope_course;
    entity.subject_point = value.subject_point;
    entity.where_know = value.where_know;
    entity.where_know_other = value.where_know_other;
    entity.why_application = value.why_application;
    entity.reason_application = value.reason_application;
    entity.issues = value.issues;
    entity.education_plan = value.education_plan;
    entity.needto_sign_language = value.needto_sign_language;
    entity.needto_pronunciation = value.needto_pronunciation;
    entity.needto_hearing = value.needto_hearing;
    entity.school_subject_needs = value.school_subject_needs;
    entity.other_needs = value.other_needs;
    entity.insert_dt = value.insert_dt;
    entity.has_deafness_class = value.has_deafness_class;
    entity.can_up_photo = value.can_up_photo;
    entity.has_ryouiku_techo = value.has_ryouiku_techo;
    entity.is_yuucho = value.is_yuucho;
    entity.kp_id = value.kp_id;
    entity.kp_downloaded = value.kp_downloaded;
    return entity;
  }
}
